var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectWithoutContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 138,
    viewBox: "0 0 139 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connect_without_contact"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_451_3635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7726 80.2722H52.3181C52.3181 51.8076 75.399 28.7267 103.864 28.7267V40.1813C81.699 40.1813 63.7726 58.1076 63.7726 80.2722ZM103.864 63.0904V51.6358C88.0563 51.6358 75.2272 64.4649 75.2272 80.2722H86.6817C86.6817 70.7649 94.3563 63.0904 103.864 63.0904ZM40.8635 22.9995C40.8635 16.6422 35.7663 11.5449 29.409 11.5449C23.0517 11.5449 17.9544 16.6422 17.9544 22.9995C17.9544 29.3567 23.0517 34.454 29.409 34.454C35.7663 34.454 40.8635 29.3567 40.8635 22.9995ZM66.3499 25.8631H54.8954C53.5208 33.9958 46.5335 40.1813 37.9999 40.1813H12.2272V63.0904H46.5908V50.1467C57.2435 46.7676 65.2044 37.3749 66.3499 25.8631ZM109.591 97.454C115.948 97.454 121.045 92.3567 121.045 85.9995C121.045 79.6422 115.948 74.5449 109.591 74.5449C103.234 74.5449 98.1363 79.6422 98.1363 85.9995C98.1363 92.3567 103.234 97.454 109.591 97.454ZM101 103.181C92.4663 103.181 85.479 96.9958 84.1044 88.8631H72.6499C73.7954 100.375 81.7563 109.768 92.409 113.147V126.09H126.773V103.181H101Z",
    fill: "#447D00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_451_3635",
    x: 9.22717,
    y: 9.54492,
    width: 120.545,
    height: 120.545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.294118 0 0 0 0 0.286275 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_451_3635"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_451_3635",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWithoutContact);
export default __webpack_public_path__ + "static/media/connect-without-contact.0ea12d86afe6f19d9e344d0448c9b8fc.svg";
export { ForwardRef as ReactComponent };